<template>
  <main class="justify-between overflow-y-auto h-screen flow-x-hidden flexflex-col">
    <Header :loggedIn="loggedIn" />
    <Nav :loggedIn="loggedIn" />
    <div class="mb-20">
      <slot />
    </div>
    <Footer />
  </main>
</template>

<script>
import Header from "./components/Header";

import Footer from "./components/Footer";
export default {
  name: "default-layout",
  props: ["loggedIn"],
  components: {
    Header,
    Footer,
  },
  computed: {
    homePage() {
      if (this.$route.path == "/") {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease-out-in;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
body {
  background-color: #e1e1e1;
}
.form-wrapper {
  border-radius: 7px;
}
.form-wrapper label {
  font-weight: bold;
}
.errors li {
  list-style: none;
  width: 100%;
  text-align: center;
}
.errors ul {
  padding-left: 0;
  margin-bottom: 0;
}

@media (max-width: 768px) {
  .form-wrapper .text-right {
    text-align: center !important;
  }

  .form-wrapper .btn-primary {
    display: block;
    margin: 0 auto;
  }
}
</style>
